import { Component, Input } from '@angular/core';
import { Flight, Passenger } from 'src/app/core/models/itinerary.model';

@Component({
  selector: 'app-itinerary-resume',
  templateUrl: './itinerary-resume.component.html',
  styleUrls: ['./itinerary-resume.component.scss']
})
export class ItineraryResumeComponent {
  @Input() flights: Flight[];
  @Input() flightsTitle: string;
  @Input() passengers: Passenger[];
}
